export interface UiState {
  isContentLoading: boolean;
  isModalLoading?: boolean;
  isUserIdle?: boolean;
}

export const initialUiState: UiState = {
  isContentLoading: false,
  isModalLoading: false,
  isUserIdle: false,
};
